(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["hallway-countdown"] && !Shopify.designMode) return;
  try {
    class HallwayCountdown extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.targetTimestamp = parseInt(this.dataset.targetTimestamp, 10);
    this.expiryBehaviour = this.dataset.expiryBehaviour;
    this.expiryText = this.dataset.expiryText;

    if (isNaN(this.targetTimestamp)) {
      console.error('[Hallway] Countdown: Invalid target timestamp');
      return;
    }

    this.update();
    this.interval = setInterval(this.update.bind(this), 1000);
  }

  disconnectedCallback() {
    if (this.interval) {
      clearInterval(this.interval);
    }
  }

  update() {
    const now = Date.now();
    // Liquid timestamp is in seconds, convert to ms
    const distance = (this.targetTimestamp * 1000) - now;

    if (distance < 0) {
      if (this.interval) clearInterval(this.interval);
      this.handleExpiry();
      return;
    }

    const days = Math.floor(distance / (1000 * 60 * 60 * 24));
    const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((distance % (1000 * 60)) / 1000);

    let output = '';
    if (days > 0) output += `${days}d `;
    output += `${hours}h ${minutes}m ${seconds}s`;

    this.textContent = output;
    this.style.display = ''; // Ensure visible
  }

  handleExpiry() {
    if (this.expiryBehaviour === 'hide') {
      this.style.display = 'none';
    } else if (this.expiryBehaviour === 'show_text') {
      this.textContent = this.expiryText;
    }
  }
}

if (!customElements.get('hallway-countdown')) {
  customElements.define('hallway-countdown', HallwayCountdown);
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["hallway-tag-mega-menu-image-swap"] && !Shopify.designMode) return;
  try {
    document.addEventListener('page:loaded', function() {

        window.hw__preloadedImages = [];
        document.querySelectorAll('[data-hallway-mega-menu-image-child]').forEach(el => {

            // find the master image for this menu column
            const hw__masterImage = el.parentElement.parentElement.querySelector('[data-hallway-mega-menu-image-master]');

            if (hw__masterImage) {

                // preload image
                window.hw__preloadedImages.push(new Image().src = el.dataset.hallwayMegaMenuImageSrc);

                const hw__hoverImagePropertyValue = `url(${el.dataset.hallwayMegaMenuImageSrc})`;

                el.addEventListener('mouseover', (event) => {
                    event.stopPropagation();
                    if (hw__masterImage.style.backgroundImage !== hw__hoverImagePropertyValue) {
                        hw__masterImage.style.backgroundImage = hw__hoverImagePropertyValue;
                    }
                });

                const hw__masterImagePropertyValue = `url(${hw__masterImage.dataset.hallwayMegaMenuImageSrc})`;

                el.addEventListener('mouseout', (event) => {
                    event.stopPropagation();
                    if (hw__masterImage.style.backgroundImage !== hw__masterImagePropertyValue) {
                        hw__masterImage.style.backgroundImage = hw__masterImagePropertyValue;
                    }
                });

            }

        });

    });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["hw-banner-countdown"] && !Shopify.designMode) return;
  try {
    class HallwayBannerCountdown extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.targetTimestamp = parseInt(this.dataset.targetTimestamp, 10);
      this.expiryBehaviour = this.dataset.expiryBehaviour;
      this.expiryText = this.dataset.expiryText;
      this.countdownPrefix = this.dataset.prefix || '';

      if (isNaN(this.targetTimestamp)) {
        console.error('[Hallway] Banner Countdown: Invalid target timestamp');
        return;
      }

      this.update();
      this.interval = setInterval(this.update.bind(this), 1000);
    }

    disconnectedCallback() {
      if (this.interval) {
        clearInterval(this.interval);
      }
    }

    update() {
      const now = Date.now();
      const distance = (this.targetTimestamp * 1000) - now;

      if (distance < 0) {
        if (this.interval) clearInterval(this.interval);
        this.handleExpiry();
        return;
      }

      const days = Math.floor(distance / (1000 * 60 * 60 * 24));
      const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((distance % (1000 * 60)) / 1000);

      let output = '';
      if (days > 0) output += `${days}d `;
      output += `${hours}h ${minutes}m ${seconds}s`;

      if (this.countdownPrefix) output = `${this.countdownPrefix} ${output}`;

      this.textContent = output;
      this.style.display = '';
    }

    handleExpiry() {
      if (this.expiryBehaviour === 'hide') {
        this.style.display = 'none';
      } else if (this.expiryBehaviour === 'show_message') {
        this.textContent = this.expiryText;
      }
    }
  }

  if (!customElements.get('hallway-banner-countdown')) {
    customElements.define('hallway-banner-countdown', HallwayBannerCountdown);
  }
  } catch(e) { console.error(e); }
})();

})();
